import { MessagingEventSource } from "../../messaging/types/socket";

export const TargetGroup = {
  Expert: "EXPERT",
  Customer: "CUSTOMER",
  Talent: "TALENT",
} as const;

export type TargetGroupType = (typeof TargetGroup)[keyof typeof TargetGroup];

export const Severity = {
  Info: "INFO",
  Warning: "WARNING",
  Critical: "CRITICAL",
} as const;

export type SeverityType = (typeof Severity)[keyof typeof Severity];

export interface AnnouncementItem {
  id: string;
  startAt: string;
  endAt: string;
  targetGroups: TargetGroupType[];
  messages: {
    languageCode: string;
    text: string;
  }[];
  severity: SeverityType;
  version: number;
  active?: boolean;
}

export type AnnouncementPayload = Omit<AnnouncementItem, "id" | "version">;

export interface AnnouncementResponse {
  items: AnnouncementItem[];
  nextToken?: string;
}

export interface DeleteAnnouncementPayload {
  id: string;
  version: number;
}

export enum AnnouncementEventType {
  ANNOUNCEMENT_CREATED = "ANNOUNCEMENT_CREATED",
  ANNOUNCEMENT_UPDATED = "ANNOUNCEMENT_UPDATED",
  ANNOUNCEMENT_DELETED = "ANNOUNCEMENT_DELETED",
  ANNOUNCEMENT_STARTED = "ANNOUNCEMENT_STARTED",
  ANNOUNCEMENT_ENDED = "ANNOUNCEMENT_ENDED",
}

export interface SocketAnnouncementEvent<T> {
  id: string;
  type: AnnouncementEventType;
  source: MessagingEventSource;
  timestamp: string; // ISO format
  senderId: string;
  payload: { announcement: T };
}
